import { PublicDevelopmentManagerDetailsPageTemplate, PublicTemplate } from "../../../../../templates";
import { useDetails } from "./useDetails";

const Details = (): JSX.Element => {
  const { dataIsLoading, developmentManagerDetailsData } = useDetails();

  return (
    <PublicTemplate activeElement="Project list" isContentUnwrapped>
      {!dataIsLoading && developmentManagerDetailsData && (
        <PublicDevelopmentManagerDetailsPageTemplate developmentManagerDetailsData={developmentManagerDetailsData} />
      )}
    </PublicTemplate>
  );
};

export default Details;
